import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <circle cx={9} cy={9} r={9} />
    <g fill="#fff">
      <path d="M9 8.093a5.83 5.83 0 0 0-4.162 1.745l.849.849a4.632 4.632 0 0 1 6.626 0l.849-.849A5.83 5.83 0 0 0 9 8.093zM9 10.843c-.869 0-1.654.362-2.217.94l.848.848c.346-.361.83-.589 1.369-.589s1.023.228 1.369.589l.848-.848A3.088 3.088 0 0 0 9 10.843z" />
      <path d="M9 5.343a8.574 8.574 0 0 0-6.106 2.552l.848.848c1.342-1.357 3.203-2.2 5.258-2.2s3.916.843 5.258 2.2l.848-.848A8.57 8.57 0 0 0 9 5.343z" />
    </g>
  </svg>
);

export default SvgComponent;
